import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const errorString = error?.message || error?.toString() || '';

    const isChunkLoadFailed =
      errorString.includes('Loading chunk') ||
      errorString.includes('ChunkLoadError') ||
      errorString.includes('Failed to fetch dynamically imported module');

    if (isChunkLoadFailed) {
      console.warn(
        'Chunk loading failed. Reloading the page to fetch the latest version...',
      );
      // Force reload from the server, bypassing local cache
      window.location.reload();
      return;
    }

    console.error(error);
  }
}
